import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useQuoteStatusReducer = () =>
  useSelector((state: ApplicationState) => state.quoteStatus);